import React from 'react';
import { Button, Table, Modal, Tabs, Input, Radio, Checkbox, Row, Col, Form, message } from 'antd';
import AddressModal from '../AddressModal';
import { useModel } from '../../use';
import { asserts, network, generators } from '../../../utils';
import api from '../../../config/api';
import { linkTo } from '../../../utils/biz';
import './index.less';
import { typeOf } from 'mathjs';

const FormItem = Form.Item;

let msgTip = null;
export default Form.create({ name: 'Forms' })(
  ({ form, wrapClassName, fillSuverys, suverysFillFlag, questionList, handleCancel, history }) => {
    const [fillFlag, setFillFlag] = React.useState(false);
    const [fillSuverysVisible, setFillSuverysVisible] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [modalVisible, setModalVisible] = React.useState(false);
    const [submitInfos, setSubmitInfos] = React.useState({});
    const [addrInfo, setAddrInfo] = React.useState({});
    const [addrVisible, setAddrVisible] = React.useState(false);
    const [publishFlag, setPublishFlag] = React.useState(false);
    const [btnLoading, setBtnLoading] = React.useState(false);
    const { getFieldDecorator, validateFields, getFieldValue, resetFields } = form;

    React.useEffect(() => {
      setFillFlag(suverysFillFlag);
    }, [suverysFillFlag]);

    React.useEffect(() => {
      setFillSuverysVisible(fillSuverys);
    }, [fillSuverys]);

    const submit = async (data) => {
      setConfirmLoading(true);
      const res = await network({
        url: api.core.submitFillSuvery,
        method: 'post',
        data,
      });
      if (res.success) {
        const result = generators.generatorObject(res.data);
        if (!result.success) {
          message.error(result.message);
          setConfirmLoading(false);
          return;
        }
        // resetFields();
        const { score, currentTurns, remainNumber, fillFlag, reward } = result.data;
        const submitInfos = {
          score, // 答题分数
          currentTurns, // 当前填写次数
          remainNumber, // 剩余次数
          fillFlag, // 是否可以再次填写
          reward, // 奖项信息
        };
        setSubmitInfos(submitInfos);
        setModalVisible(true);
        setConfirmLoading(false);
        // let msg = null;
        // if (asserts.isExist(score)) {
        //   msg = `问卷提交成功，得分${score}分`;
        // } else {
        //   msg = `问卷提交成功`;
        // }
        // message
        //   .success(`${msg}${questionList.drawFlag === 1 ? ',恭喜你获得一次抽奖机会!' : ''}`, 2)
        //   .then(() => {
        //     if (questionList.drawFlag === 1) {
        //       history.push('/activityZone/draw');
        //     } else {
        //       history.push('/home');
        //     }
        //   });
        // setConfirmLoading(false);
      } else {
        message.error('问卷提交失败！');
        setConfirmLoading(false);
      }
    };
    const handleSubmit = () => {
      validateFields((err, val) => {
        const params = questionList.questions.map((item) => {
          return { qusId: item.id, optId: val[item.id], suvId: `${item.suvId}` };
        });
        if (err) {
          return;
        }
        let arr = [];
        for (let key in val) {
          if (key.indexOf('-') != -1) {
            const value = key.split('-');
            const newValue = {
              qusId: value[0],
              optId: value[1],
              optContent: val[key],
              suvId: `${questionList.id}`,
            };
            arr.push(newValue);
          } else if (typeOf(val[key]) === 'number') {
            const newValue = { qusId: key, optId: `${val[key]}`, suvId: `${questionList.id}` };
            arr.push(newValue);
          } else if (typeOf(val[key]) === 'Array') {
            val[key].forEach((item) => {
              arr.push({ qusId: key, optId: `${item}`, suvId: `${questionList.id}` });
            });
          }
        }
        submit(arr);
      });
    };

    const renderFooter = () => {
      const { score, remainNumber, reward } = submitInfos;
      if (questionList.drawFlag === 1) {
        // 说明是和抽奖做关联得
        if (asserts.isExist(reward)) {
          msgTip = `本次答题分数${score}分，${
            reward.discountName > 0 ? `获取${reward.discountName}次抽奖机会` : ''
          },还剩${remainNumber}次答题机会`;
        } else {
          msgTip = `本次答题分数${score}分,还剩${remainNumber}次答题机会`;
        }
        return [
          <Button onClick={handleGoPage}>
            不再作答，
            {asserts.isExist(reward) && reward.discountName > 0
              ? '获得抽奖机会并前往抽奖页面'
              : null}
          </Button>,
          remainNumber > 0 ? (
            <Button onClick={handleAnswerAgain} type="primary">
              再次作答
            </Button>
          ) : null,
        ];
      } else {
        // 说明是和奖励有关的
        if (asserts.isExist(reward)) {
          // 说明跟奖励关联
          msgTip = `本次答题分数${score}分，${
            reward.discountType === 'A'
              ? `获取优惠券${reward.custCoupon.cpnName}`
              : reward.discountType === 'B'
              ? `获取奖励为${reward.discountName}`
              : null
          },${remainNumber > 0 ? `还剩${remainNumber}次答题机会` : '没有答题机会了'}`;
          return [
            <Button onClick={() => handleGetAnswer(true)} loading={btnLoading}>
              不再作答，公布正确答案
            </Button>,
            remainNumber > 0 ? (
              <Button onClick={handleAnswerAgain} type="primary">
                再次作答,暂不领取奖励
              </Button>
            ) : null,
          ];
        } else {
          msgTip = `本次答题分数${score}分,还剩${remainNumber}次答题机会`;
          return [
            <Button onClick={() => handleGetAnswer(false)} loading={btnLoading}>
              不再作答，公布正确答案
            </Button>,
            remainNumber > 0 ? (
              <Button onClick={handleAnswerAgain} type="primary">
                再次作答
              </Button>
            ) : null,
          ];
        }
      }
    };

    // 不再作答，获得抽奖机会并前往抽奖页面
    const handleGoPage = () => {
      setModalVisible(false);
      history.push('/activityZone/draw');
    };

    // 再次作答  刷新页面
    const handleAnswerAgain = () => {
      resetFields();
      setModalVisible(false);
      resetFields();
    };

    // 不再作答，公布正确答案  需要判断有没有奖励
    const handleGetAnswer = async (flag) => {
      if (flag) {
        const { reward } = submitInfos;
        if (reward.discountType === 'B') {
          // 自定义奖励需要选择收货地址
          fetchAddr();
          return;
        } else {
          getRewards({});
        }
      } else {
        setModalVisible(false);
        setFillFlag(false);
        setPublishFlag(true);
      }
    };

    const getRewards = async (values) => {
      // 需要领取奖励 或者优惠券
      const { currentTurns, reward } = submitInfos;
      setBtnLoading(true);
      const res = await network({
        url: api.core.getRewards,
        method: 'post',
        data: {
          suvId: reward.suvId,
          paperId: currentTurns,
          discountId: reward.discountId,
          discountType: reward.discountType,
          discountName:
            reward.discountType === 'A' ? reward.custCoupon.cpnName : reward.discountName,
          receiveAddr: values.address,
        },
      });
      setBtnLoading(false);
      if (res.success) {
        message.success(res.data.message);
      } else {
        message.error(res.message || '领取奖励失败');
      }
      setPublishFlag(true);
      setModalVisible(false);
    };

    // 拉取配置过的地址
    const fetchAddr = async () => {
      const response = await network.get(api.activeArea.luckyDraw.addrDefault);
      if (response.success) {
        const result = generators.generatorObject(response.data);
        setAddrInfo(generators.generatorObject(result.data));
        setAddrVisible(true);
      }
    };

    const onUpdateAddConfirm = (values) => {
      setAddrInfo(values);
      // 需要领取奖励
      getRewards(values);
    };

    const handleAddrCancel = () => {
      setAddrVisible(false);
    };

    return (
      <>
        <div>
          <Modal
            title="调查问卷"
            width={920}
            visible={fillSuverysVisible}
            wrapClassName={wrapClassName}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            // onOk={handleSubmit}
            footer={
              fillFlag
                ? [
                    <Button type="default" onClick={handleCancel}>
                      取消
                    </Button>,
                    <Button type="primary" onClick={handleSubmit}>
                      确定
                    </Button>,
                  ]
                : null
            }
          >
            <h2 className="title">{questionList.title}</h2>
            <p className="summary">{questionList.suvSummary}</p>
            <Form layout="vertical" className="fillSuveryForm">
              {questionList.questions.map((item, index) =>
                item.qusType === 1 ? (
                  <FormItem label={`${index + 1}、${item.qusTitle}`} key={index}>
                    {getFieldDecorator(`${item.id}`, {
                      initialValue: publishFlag
                        ? item.options.filter((itm) => itm.answerFlag)[0].id
                        : '',
                      rules: [
                        {
                          required: true,
                          message: '请填写问卷内容',
                        },
                      ],
                    })(
                      <Radio.Group disabled={!fillFlag}>
                        {item.options.map((v, i) => (
                          <Radio value={v.id} key={i} className="blockStyle">
                            {v.opContent}
                          </Radio>
                        ))}
                      </Radio.Group>,
                    )}
                  </FormItem>
                ) : item.qusType === 2 ? (
                  <FormItem label={`${index + 1}、${item.qusTitle}`} key={index}>
                    {getFieldDecorator(`${item.id}`, {
                      initialValue: publishFlag
                        ? item.options.filter((itm) => itm.answerFlag).map((v) => v.id)
                        : [],
                      rules: [
                        {
                          required: true,
                          message: '请填写问卷内容',
                        },
                      ],
                    })(
                      <Checkbox.Group disabled={!fillFlag}>
                        {item.options.map((v, i) => (
                          <Checkbox
                            value={v.id}
                            key={i}
                            className="blockStyle"
                            style={{ margin: 0 }}
                          >
                            {v.opContent}
                          </Checkbox>
                        ))}
                      </Checkbox.Group>,
                    )}
                  </FormItem>
                ) : item.qusType === 3 ? (
                  <FormItem label={`${index + 1}、${item.qusTitle}`} key={index}>
                    {getFieldDecorator(`${item.id}`, {
                      rules: [
                        {
                          required: true,
                          message: '请填写问卷内容',
                        },
                      ],
                    })(
                      <Row style={{ marginTop: 10, marginLeft: 30 }}>
                        {item.options.map((v, i) => (
                          <Col span={8} key={i}>
                            <FormItem>
                              {getFieldDecorator(`${item.id}-${v.id}`, {
                                // rules: [
                                //   {
                                //     required: true,
                                //     message: '请填写问卷内容',
                                //   },
                                // ],
                              })(
                                <span>
                                  <span>{v.opContent}： </span>
                                  <Input key={i} style={{ width: 200 }} disabled={!fillFlag} />
                                </span>,
                              )}
                            </FormItem>
                          </Col>
                        ))}
                      </Row>,
                    )}
                  </FormItem>
                ) : (
                  <FormItem label={`${index + 1}、${item.qusTitle}`} key={index}>
                    {getFieldDecorator(`${item.id}-${item.options[0].id}`, {
                      rules: [
                        {
                          required: true,
                          message: '请填写问卷内容',
                        },
                      ],
                    })(
                      <Input.TextArea
                        style={{ marginLeft: 30, width: 810 }}
                        disabled={!fillFlag}
                      />,
                    )}
                  </FormItem>
                ),
              )}
            </Form>
          </Modal>
        </div>
        {modalVisible ? (
          <Modal
            title="答题结果"
            width={600}
            visible={modalVisible}
            destroyOnClose
            footer={renderFooter()}
            onCancel={() => setModalVisible(false)}
          >
            <div>{msgTip}</div>
          </Modal>
        ) : null}
        {addrVisible ? (
          <AddressModal
            addrInfo={addrInfo}
            onConfirm={onUpdateAddConfirm}
            addrVisible={addrVisible}
            handleAddrCancel={handleAddrCancel}
            okLoading={btnLoading}
          />
        ) : null}
      </>
    );
  },
);
